export default __webpack_public_path__ + "static/media/04.204f6d1a.jpg";